import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/record`,
    name: 'MAINTAIN_RECORD_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
